import script from "./onls-title.vue?vue&type=script&setup=true&lang=ts"
export * from "./onls-title.vue?vue&type=script&setup=true&lang=ts"

import "./onls-title.vue?vue&type=style&index=0&id=03293b26&lang=scss"

const __exports__ = script;

export default __exports__